var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_vm._t("always-visible"),_vm._v(" "),_c('show-more',{attrs:{"collapsedHeight":"2","evtrkCategory":_vm.evtrkCategory,"evtrkAction":_vm.evtrkAction}},[_vm._t("default")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }